function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M55.4 10.2c2.4 0 4.6 2 4.6 4.6v40.6c0 2.4-2 4.6-4.6 4.6h-46.8c-2.4 0-4.6-2-4.6-4.6v-40.6c0-2.4 2-4.6 4.6-4.6h46.8z",
  fill: "none",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M60 28.8h-56",
  fill: "none",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.4 4v12.4",
  fill: "none",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.6 4v12.4",
  fill: "none",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 50.6c0 0.8-0.6 1.6-1.6 1.6-0.8 0-1.6-0.6-1.6-1.6 0-0.8 0.6-1.6 1.6-1.6s1.6 0.8 1.6 1.6z",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.6 50.6c0 0.8-0.6 1.6-1.6 1.6s-1.6-0.6-1.6-1.6c0-0.8 0.6-1.6 1.6-1.6s1.6 0.8 1.6 1.6z",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.2 50.6c0 0.8-0.6 1.6-1.6 1.6s-1.6-0.8-1.6-1.6 0.6-1.6 1.6-1.6 1.6 0.8 1.6 1.6z",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 38.2c0 0.8-0.6 1.6-1.6 1.6-0.8 0-1.6-0.6-1.6-1.6s0.6-1.6 1.6-1.6 1.6 0.8 1.6 1.6z",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.6 38.2c0 0.8-0.6 1.6-1.6 1.6s-1.6-0.6-1.6-1.6 0.6-1.6 1.6-1.6 1.6 0.8 1.6 1.6z",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.2 38.2c0 0.8-0.6 1.6-1.6 1.6s-1.6-0.8-1.6-1.6 0.6-1.6 1.6-1.6 1.6 0.8 1.6 1.6z",
  strokeMiterlimit: 10
}));

var SvgValidity = function SvgValidity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgValidity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/validity.b93e3270.svg";
export { ForwardRef as ReactComponent };